module.exports = __webpack_public_path__ + "media/images/etyekilogo-600x600-2c2db7cf317e1d323f84a93d575141dd.png";